module.exports = __webpack_public_path__ + "img/98.61188b19.png";